import type { BusinessType, Country, Response } from "~/types";

interface CreateBusinessResponse {
  countries: Country[];
  business_types: BusinessType[];
}

export const useProfile = () => {
  const { apiVersion } = useRuntimeConfig().public;

  const getCountries = async () => {
    const { data } = await useLarafetch(`/api/${apiVersion}/countries`);
    return data.value as Response<{ countries: Country[] }>;
  };

  const getRequestDemo = async () => {
    const { data } = await useLarafetch(`/api/${apiVersion}/request-demo`);
    return data.value as Response<CreateBusinessResponse>;
  };

  return {
    getCountries,
    getRequestDemo,
  };
};
